import { render } from "./TranslatableField.vue?vue&type=template&id=7983404e&scoped=true"
import script from "./TranslatableField.vue?vue&type=script&lang=js"
export * from "./TranslatableField.vue?vue&type=script&lang=js"

import "./TranslatableField.vue?vue&type=style&index=0&id=7983404e&lang=scss&scoped=true"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7983404e"],['__file',"TranslatableField.vue"]])

export default __exports__